module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('el-select', {
    staticStyle: {
      "float": "left",
      "margin-left": "1%"
    },
    attrs: {
      "size": _vm.selectSize,
      "placeholder": "点击以筛选"
    },
    model: {
      value: (_vm.selectValue),
      callback: function($$v) {
        _vm.selectValue = $$v
      },
      expression: "selectValue"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "2%",
      "text-align": "center",
      "line-height": "35px",
      "font-size": "16px"
    }
  }, [_vm._v("标题/内容:")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "180px",
      "float": "left",
      "margin-left": "1%"
    },
    attrs: {
      "placeholder": "输入水表编号用以检索",
      "prefix-icon": "el-icon-search",
      "autofocus": "first_input",
      "clearable": ""
    },
    model: {
      value: (_vm.counterCode),
      callback: function($$v) {
        _vm.counterCode = $$v
      },
      expression: "counterCode"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "iconfont icon-search",
    staticStyle: {
      "float": "left",
      "margin-left": "2%"
    },
    attrs: {
      "type": "primary",
      "icon": "icon-search"
    },
    on: {
      "click": _vm.searchData
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "infinite-list",
    staticStyle: {
      "float": "center",
      "height": "500px",
      "width": "100%",
      "overflow": "auto"
    },
    attrs: {
      "infinite-scroll-disabled": "busy",
      "infinite-scroll-distance": "5",
      "infinite-scroll-delay": "2000"
    }
  }, _vm._l((_vm.countData), function(item) {
    return _c('div', {
      key: item
    }, [(item.state === 1) ? _c('div', {
      staticClass: "except-div except-div2"
    }, [_c('div', {
      staticClass: "except-title"
    }, [_vm._v("异常: \n            "), (item.type === 0) ? _c('b', {
      staticClass: "except-b"
    }, [_vm._v("漏抄表")]) : _vm._e(), _vm._v(" "), (item.type === 1) ? _c('b', {
      staticClass: "except-b"
    }, [_vm._v("无数据")]) : _vm._e(), _vm._v(" "), (item.type === 2) ? _c('b', {
      staticClass: "except-b"
    }, [_vm._v("行码较之前小")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "except-counter"
    }, [_vm._v("表号:" + _vm._s(item.counterCode))]), _vm._v(" "), _c('div', {
      staticClass: "except-time"
    }, [_vm._v("异常时间：" + _vm._s(item.copyTime))]), _vm._v(" "), _c('div', {
      staticClass: "except-time"
    }, [_vm._v("处理结果：" + _vm._s(item.remarks))]), _vm._v(" "), (item.state == 1) ? _c('div', {
      staticClass: "except-button card-un",
      on: {
        "click": function($event) {
          _vm.checkData(item.num, item.counts)
        }
      }
    }, [_vm._v("查看")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.state === 0) ? _c('div', {
      staticClass: "except-div except-div3"
    }, [_c('div', {
      staticClass: "except-title"
    }, [_vm._v("异常: \n            "), (item.type === 0) ? _c('b', {
      staticClass: "except-b"
    }, [_vm._v("漏抄表")]) : _vm._e(), _vm._v(" "), (item.type === 1) ? _c('b', {
      staticClass: "except-b"
    }, [_vm._v("无数据")]) : _vm._e(), _vm._v(" "), (item.type === 2) ? _c('b', {
      staticClass: "except-b"
    }, [_vm._v("行码较之前小")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "except-counter"
    }, [_vm._v("表号:" + _vm._s(item.counterCode))]), _vm._v(" "), _c('div', {
      staticClass: "except-time"
    }, [_vm._v("异常时间：" + _vm._s(item.copyTime))]), _vm._v(" "), (item.state == 0) ? _c('div', {
      staticClass: "except-button card-on",
      on: {
        "click": function($event) {
          _vm.checkData(item.num, item.counts)
        }
      }
    }, [_vm._v("处理")]) : _vm._e()]) : _vm._e()])
  })), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "漏抄表处理记录",
      "visible": _vm.dialogFormVisible,
      "modal-append-to-body": false,
      "show-close": true,
      "width": "200px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "表号",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.form2.counterCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "缺失抄表日期",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.form2.copyTime))])]), _vm._v(" "), (_vm.form2.type === 0) ? _c('el-form-item', {
    attrs: {
      "label": "应抄次数",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.form2.planTimes))])]) : _vm._e(), _vm._v(" "), (_vm.form2.type === 0) ? _c('el-form-item', {
    attrs: {
      "label": "实抄次数",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.form2.actualTimes))])]) : _vm._e(), _vm._v(" "), (_vm.form2.type !== 0) ? _c('el-form-item', {
    attrs: {
      "label": "异常抄表图片",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "80px"
    },
    attrs: {
      "src": _vm.form2.imageUrl
    }
  })])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "处理结果",
      "label-width": _vm.formLabelWidth
    }
  }, [(_vm.form2.state == 0) ? _c('el-input', {
    staticStyle: {
      "width": "410px"
    },
    attrs: {
      "type": "textarea",
      "autosize": "",
      "placeholder": "请填入您的处理结果",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form2.remarks),
      callback: function($$v) {
        _vm.$set(_vm.form2, "remarks", $$v)
      },
      expression: "form2.remarks"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form2.state != 0) ? _c('div', [_vm._v(_vm._s(_vm.form2.remarks))]) : _vm._e()], 1), _vm._v(" "), (_vm.form2.state == 1) ? _c('el-form-item', {
    attrs: {
      "label": "处理时间",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.form2.updateTime))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.toUpdateState(_vm.form2.counts)
      }
    }
  }, [_vm._v("提 交")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a01e2250","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Except/copyData.vue
// module id = 1796
// module chunks = 1